import{a as i}from"./ninox-components-ED6G4JEG.js";import{l as o}from"./ninox-components-GQTCIGTF.js";import{m as e}from"./ninox-components-2ADN25D5.js";import t from"styled-components";var p=t.fieldset`
    display: flex;
    flex-flow: row wrap;
    align-items: flex-end;
    gap: ${e.x_small} ${e.medium};
    border: none;
    margin: 0;
    padding: 0;
`,l=t(i)`
    width: ${o.l};
`;export{p as a,l as b};
//# sourceMappingURL=ninox-components-OX2TKBMX.js.map